import { API_URL, ASSETS, URL, PLATFORM_FEE } from '../config.js';
import { printdDate } from '../helper.js';
import View from './View';

class contactView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Contact View Error Message';
  _message = 'Contact View Success Message';

  _generateMarkup() {
    return `
         <div class="row contact">
        <h1 class="heading__static">Contact Us</h1>
        <div class="contact__address--container">
          <address class="contact__address">
            <p>37/A, Garcha Road, Kolkata, - 700019</p>

            <div class="footer__btn--container">
              <a href="tel:03335518195" class="btn link">
                <p class="btn--footer">
                  <svg class="icon contact__icon">
                    <use xlink:href="../img/sprite.svg#icon-phone"></use>
                  </svg>
                  <span class="phone">35518195</span>
                </p>
              </a>
            </div>
          </address>

          <address class="contact__address">
            <p>134, Mahatma Gandhi Road, Kolkata - 700007</p>

            <div class="footer__btn--container">
              <a href="tel:03322693875" class="btn link">
                <p class="btn--footer">
                  <svg class="icon contact__icon">
                    <use xlink:href="../img/sprite.svg#icon-phone"></use>
                  </svg>
                  <span class="phone">2269-3875</span>
                </p>
              </a>
            </div>
          </address>
          <address class="contact__address">
            <p>AE-332, Salt Lake City, Sector-1, Kolkata - 700004</p>

            <div class="footer__btn--container">
              <a href="tel:03323378556" class="btn link">
                <p class="btn--footer">
                  <svg class="icon contact__icon">
                    <use xlink:href="../img/sprite.svg#icon-phone"></use>
                  </svg>
                  <span class="phone">2337-8556</span>
                </p>
              </a>
            </div>
          </address>
        </div>

        <p class="paragraph">
          Email:
          <a href="mailto:pragya231006@gmail.com" class="link"
            >pragya231006@gmail.com</a
          >
        </p>
      </div>
    
       
    `;
  }
}

export default new contactView();
